import { Button } from "@/components/common/Button";
import { useUserStore } from "@/modules/auth/store/user";
import { formatEllipsis, formatNumber } from "@/modules/auth/utils/format";
import { useEvmBtnBalance } from "@/shared/base/useEvmBtnBalance";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

const ConnectedWalletMeBASE = () => {
  const { t } = useTranslation();
  const { user, setWalletBalance } = useUserStore();
  const navigate = useNavigate();

  const address = user?.walletId ? user.walletId.split(".")[2] : null;

  const { balance, isLoading } = useEvmBtnBalance(
    (address as `0x${string}`) || undefined
  );

  const { activeBalance, isActiveLoading } = useMemo(
    () =>
      ({ activeBalance: balance ?? "0", isActiveLoading: isLoading } as const),
    [balance, isLoading]
  );

  useEffect(() => {
    if (!address) {
      setWalletBalance(0);
      return;
    }

    if (isActiveLoading) return;

    const parsed = parseFloat(activeBalance);
    setWalletBalance(Number.isFinite(parsed) ? parsed : 0);
  }, [address, isActiveLoading, activeBalance, setWalletBalance]);

  const handleConnect = () => {
    navigate("/settings");
  };

  return (
    <div className="flex w-full flex-col">
      <p className="p-4 pb-2 text-[0.8125rem] leading-[1rem] text-section-header-text tracking-tighter uppercase">
        {t("deposit-page.connected_wallet")}
      </p>
      <div className="flex items-center justify-between bg-bg rounded-[0.75rem] px-4 py-3">
        <div className="flex flex-col gap-0.5">
          <div className="flex items-center">
            {isLoading && (
              <div className="w-8 h-[1.375rem] rounded-sm bg-skeleton"></div>
            )}
            <p className="text-[1.0625rem] leading-[1.375rem] text-text">
              {!isLoading && formatNumber(Number(activeBalance))}{" "}
              <span className="text-hint">BTN</span>
            </p>
          </div>
          {address && (
            <p className="text-[0.9375rem] leading-[1.25rem] font-semibold text-subtitle-text">
              {formatEllipsis(address)}
            </p>
          )}
        </div>

        {!address && !isLoading && (
          <Button
            onClick={handleConnect}
            text={t("main-page.connect_base_wallet")}
            size="small"
            mode="bezeled"
            pilled
          />
        )}
      </div>
    </div>
  );
};

export default ConnectedWalletMeBASE;
